import { render, staticRenderFns } from "./firstName.vue?vue&type=template&id=2a054ce0&"
import script from "./firstName.vue?vue&type=script&lang=ts&"
export * from "./firstName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports